// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"20d33943","149":"22b2fb65","255":"03225bdd","266":"eae6a479","299":"9377a904","333":"280c9b54","596":"aa332557","817":"0db9811e","888":"1b524474"}[chunkId] + ".chunk.js";
};